import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { TertiaryButton } from '@longline/aqua-ui/controls/TertiaryButton';
import { Public } from '@longline/aqua-ui/modules/Public';

import { Sprites } from '../../svg';

const NoMatch = () => {
  const navigate = useNavigate();

  return (
    <Public
      logoUrl={Sprites.Logos.LogoStandard}
      logoAspectRatio={175/82}          
      height="190px"
      hint={<>
        <strong>PAGE NOT FOUND</strong>
        <p>
          If the problem persists, get in touch with us 
          at <a href="mailto:support@longline.co.uk">support@longline.co.uk</a>.
        </p>        
      </>}
      footer={<>
        <TertiaryButton onClick={() => navigate("/")}>HOME</TertiaryButton>
      </>}
    >
      <strong>PAGE NOT FOUND</strong>
      <p>
        If you expected to see something here, go back and try again, or 
        make sure the address is typed in correctly.  
      </p>
    </Public> 
  )
}

export { NoMatch }
